/* eslint-disable */
import { create } from '../utils/sigpipe'
// import emitter from '../utils/emitter'

export default {
  name: 'map',

  ui: {
    'filters[]': '[js-map-filter]',
  },

  events: [
    {
      target: 'filters',
      on: 'click',
      handle(e) {
        const target = e.currentTarget
        for (const f of this.ui.filters) {
          if (f !== target) f.classList.remove('is-active')
        }
        target.classList.toggle('is-active')

        for (const marker of this.markersArray) {
          marker.setIcon(this.unselectedIcon)
        }

        this.clearInfos()

        let selectionArray = []
        if (target.classList.contains('is-active')) {
          const filter = target.getAttribute('js-map-filter')

          if (filter === 'headoffice') {
            selectionArray = this.markersArray.filter(m => m.isHeadOffice)
            setTimeout(() => {
              this.fillInfos(this.markersList.filter(m => m.isHeadOffice)[0])
            }, 400)
          } else if (filter === 'franceLocated') {
            selectionArray = this.markersArray.filter(m => m.franceLocated)
          } else if (filter === 'outsideLocated') {
            selectionArray = this.markersArray.filter(m => !m.franceLocated)
          } else {
            console.log('here')
          }

          this.latlngbounds = new google.maps.LatLngBounds()

          if (selectionArray.length <= 0) {
            selectionArray = [...this.markersArray]
          }

          for (const marker of selectionArray) {
            marker.setIcon(this.selectedIcon)
            this.latlngbounds.extend(
              new google.maps.LatLng(
                marker.getPosition().lat(),
                marker.getPosition().lng()
              )
            )
          }
        } else {
          selectionArray = [...this.markersArray]

          for (const marker of selectionArray) {
            marker.setIcon(this.unselectedIcon)
            this.latlngbounds.extend(
              new google.maps.LatLng(
                marker.getPosition().lat(),
                marker.getPosition().lng()
              )
            )
          }
        }

        this.centerMap()
      },
    },
  ],

  componentDidMount() {
    this.body = document.querySelector('body')
    this.mapElt = this.el.querySelector('#map')
    this.latlngbounds = {}
    this.markersArray = []
    if (this.props && this.props.markers) {
      this.markersList = this.props.markers
    }

    this.selectedIcon = {
      url: '/assets/front/marker.png',
      // This marker is 28 pixels wide by 43 pixels high.
      size: new google.maps.Size(28, 43),
      // The origin for this image is (0, 0).
      origin: new google.maps.Point(0, 0),
      // The anchor for this image is the base of the flagpole at (0, 32).
      anchor: new google.maps.Point(14, 43),
    }

    this.unselectedIcon = {
      path: google.maps.SymbolPath.CIRCLE,
      fillColor: '#00243d',
      fillOpacity: 1,
      strokeOpacity: 0.5,
      strokeWidth: 1,
      scale: 10,
    }

    this.infos = this.el.querySelector('.slice__map__infos')
    this.infosTitle = this.infos.querySelector('.slice__map__infos__title')
    this.infosAddress = this.infos.querySelector(
      '.slice__map__infos__address span'
    )
    this.infosphone = this.infos.querySelector('.slice__map__infos__phone span')
    this.infosmail = this.infos.querySelector('.slice__map__infos__email span')
    this.infosweb = this.infos.querySelector('.slice__map__infos__web span')

    this.checkMapInit()
  },

  setupMap() {
    const mapStyles = [
      {
        featureType: 'all',
        elementType: 'labels.text.fill',
        stylers: [
          {
            saturation: 36,
          },
          {
            color: '#333333',
          },
          {
            lightness: 40,
          },
        ],
      },
      {
        featureType: 'all',
        elementType: 'labels.text.stroke',
        stylers: [
          {
            visibility: 'on',
          },
          {
            color: '#ffffff',
          },
          {
            lightness: 16,
          },
        ],
      },
      {
        featureType: 'all',
        elementType: 'labels.icon',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'administrative',
        elementType: 'geometry.fill',
        stylers: [
          {
            color: '#fefefe',
          },
          {
            lightness: 20,
          },
        ],
      },
      {
        featureType: 'administrative',
        elementType: 'geometry.stroke',
        stylers: [
          {
            color: '#fefefe',
          },
          {
            lightness: 17,
          },
          {
            weight: 1.2,
          },
        ],
      },
      {
        featureType: 'landscape',
        elementType: 'geometry',
        stylers: [
          {
            color: '#f5f5f5',
          },
          {
            lightness: 20,
          },
          // { visibility: "off" }
        ],
      },
      {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [
          {
            color: '#f5f5f5',
          },
          {
            lightness: 21,
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.fill',
        stylers: [
          {
            color: '#ffffff',
          },
          {
            lightness: 17,
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [
          {
            color: '#ffffff',
          },
          {
            lightness: 29,
          },
          {
            weight: 0.2,
          },
        ],
      },
      {
        featureType: 'road.arterial',
        elementType: 'geometry',
        stylers: [
          {
            color: '#ffffff',
          },
          {
            lightness: 18,
          },
        ],
      },
      {
        featureType: 'road.local',
        elementType: 'geometry',
        stylers: [
          {
            color: '#ffffff',
          },
          {
            lightness: 16,
          },
        ],
      },
      {
        featureType: 'transit',
        elementType: 'geometry',
        stylers: [
          {
            color: '#f2f2f2',
          },
          {
            lightness: 19,
          },
        ],
      },
      {
        featureType: 'transit.line',
        elementType: 'geometry',
        stylers: [
          {
            visibility: 'on',
          },
          {
            gamma: '0.82',
          },
          {
            lightness: '-6',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [
          {
            color: '#c5d7ff',
          },
          {
            lightness: 17,
          },
        ],
      },
      /// HIDE

      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [
          {
            color: '#e1f5e0',
          },
          {
            lightness: 21,
          },
          { visibility: 'on' },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'water',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }],
      },
      {
        featureType: 'administrative.province',
        elementType: 'all',
        stylers: [
          // { visibility: "off" }
        ],
      },
      {
        featureType: 'road',
        elementType: 'all',
        stylers: [
          // { visibility: "off" }
        ],
      },
      {
        featureType: 'transit',
        elementType: 'all',
        stylers: [
          // { visibility: "off" }
        ],
      },

      {
        featureType: 'administrative.land_parcel',
        elementType: 'labels',
        stylers: [
          {
            visibility: 'off',
            // color: '#00FF00'
          },
        ],
      },
      {
        featureType: 'administrative.locality',
        elementType: 'labels',
        stylers: [
          {
            // visibility: "off"
            // color: '#0000FF'
          },
        ],
      },
      {
        featureType: 'administrative.neighborhood',
        elementType: 'labels',
        stylers: [
          {
            visibility: 'off',
            // color: '#FF0000'
          },
        ],
      },
      {
        featureType: 'administrative.province',
        elementType: 'labels',
        stylers: [
          {
            visibility: 'off',
            // color: '#FF0000'
          },
        ],
      },
      {},
    ]

    this.map = new google.maps.Map(this.mapElt, {
      zoom: 5,
      center: new google.maps.LatLng(44.170933800000014, -8.10194147499999), // new google.maps.LatLng(48.923, 2.357583),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: mapStyles,
      // scrollwheel: false,
      gestureHandling: 'greedy',
      disableDefaultUI: true,
      /* zoomControl: true,
     zoomControlOptions: {
       style: google.maps.MapTypeControlStyle.DEFAULT,
       position: google.maps.ControlPosition.RIGHT_BOTTOM,
     }, */
      minZoom: 2,
      maxZoom: 17,
      // maxZoom: this.isMobile ? 18 : this.isWide ? 7 : 5,

      // draggable: false
    })

    this.displayMarkers()
  },

  clearMarkers() {
    while (this.markersArray.length) {
      let m = this.markersArray.shift()
      m.setMap(null)
    }
  },

  displayMarkers() {
    this.latlngbounds = new google.maps.LatLngBounds()

    this.markersList.forEach(m => {
      var marker = new google.maps.Marker({
        position: {
          lat: parseFloat(m.location.lat),
          lng: parseFloat(m.location.lng),
        },
        icon: this.unselectedIcon,
        title: m.title,
        // url: m.url,
        map: this.map,
      })
      marker.isHeadOffice = m.isHeadOffice
      marker.franceLocated = m.franceLocated

      this.markersArray.push(marker)

      this.latlngbounds.extend(
        new google.maps.LatLng(
          marker.getPosition().lat(),
          marker.getPosition().lng()
        )
      )

      google.maps.event.addListener(marker, 'click', _ => {
        this.clickMarker(marker, m)
      })
    })

    this.centerMap(true)
  },

  centerMap() {
    // this.map.setCenter(this.latlngbounds.getCenter())
    this.map.fitBounds(this.latlngbounds)
  },

  clickMarker(marker, m) {
    /* this.clearMarkers()
  this.displayMarkers()
  marker.setMap(null) */

    this.markersArray.forEach((el, index) => {
      el.setIcon(this.unselectedIcon)
    })

    marker.setIcon(this.selectedIcon)

    this.fillInfos(m)

    // this.displayLocationsInfos([m])
  },

  checkMapInit() {
    // this.pipeId = this.mapElt.getAttribute('data-map-pipe-id')
    if (!window.mapPipe) {
      // GMap API not loaded already
      window.mapPipe = create()
      this.mapElt.setAttribute('data-map-pipe-id', window.mapPipe.id)
      // this.pipe = getPipe(pipeId)
      window.mapPipe.on(({ action }) => {
        // waiting for API loading

        switch (action) {
          case 'mapAPI-loaded':
            // mapPipe.destroy()
            this.setupMap()
            break

          default:
            console.og('error in action pipe')
            break
        }
      })
    } else {
      // GMap API already loaded, let's go
      // mapPipe.destroy()
      this.setupMap()
    }
  },

  fillInfos(m) {
    this.infosTitle.innerHTML = m.title
    this.infosAddress.innerHTML = m.address
    // PHONE
    if (m.phone !== '') this.infosphone.innerHTML = m.phone
    else this.infosphone.parentElement.classList.add('hidden')
    // mail
    if (m.email !== '') this.infosmail.innerHTML = m.email
    else this.infosmail.parentElement.classList.add('hidden')
    // website
    if (m.website !== '') this.infosweb.innerHTML = m.website
    else this.infosweb.parentElement.classList.add('hidden')

    this.infos.classList.add('is-active')
  },

  clearInfos() {
    this.infos.classList.remove('is-active')
    setTimeout(() => {
      this.infosTitle.innerHTML = ''
      this.infosAddress.innerHTML = ''
      this.infosphone.innerHTML = ''
      this.infosphone.parentElement.classList.remove('hidden')
      this.infosmail.innerHTML = ''
      this.infosmail.parentElement.classList.remove('hidden')
      this.infosweb.innerHTML = ''
      this.infosweb.parentElement.classList.remove('hidden')
    }, 300)
  },
}

window.initMap = function() {
  if (window.mapPipe) {
    // API loaded after component init, so 'emit' to init map
    window.mapPipe.write({ action: 'mapAPI-loaded' })
  } else {
    // API loaded before component init, pipe created only to let component auto init
    window.mapPipe = create()
    // document.querySelector('#map').setAttribute('data-map-pipe-id', window.mapPipe.id);
  }
}
